<template>
  <div>
    <h5 class="auth-logo">
      <div class="banner-container">
        <div class="bbi-banner"></div>
      </div>
    </h5>
    <b-container fluid class="p-2">
      <div
        style="
          border: 1px solid #000;
          padding: 5px;
          border-radius: 4px;
          background: #fff;
        "
      >
        <!-- Title -->
        <h5 class="text-center font-weight-bold mb-3">
          INSTRUKSI Validasi Hasil STOCK OPNAME
        </h5>

        <p style="margin-left:20px; font-size: 12px; font-weight: 500">
          <b> pelaksanaan bedasarkan Saldo Awal per {{ formatDate(today) }} </b>
          <i>(Penjualan pada {{ formatDate(today) }}, tetap diakui sebagai hasil validasi)</i>
        </p>

        <!-- Instructions -->
        <ol style="font-size: 13px; font-weight: 500; padding-left: 20px">
          <li>
            <span>1. Hitung seluruh stok fisik dari artikel yang telah ditentukan oleh Tim Internal Audit</span>
          </li>
          <li>
            <span>
              2. Input jumlah sesuai dengan hasil hitung fisik pada kolom,
              <b style="color: red;"
                >stok hasil validasi.</b
              >
            </span>
          </li>
          <li>
            <span>
              3. Tambahkan penjelasan selisih pada kolom <b style="color: red;">remark</b>, jika jumlah
              <b style="color: red;">stock hasil konsolidasi</b>, tidak sama dengan hasil hitung.
            </span>
          <li>
            <span>
              4. Pastikan data sudah benar, sebelum menekan
              tombol <b style="color: red;">Submit</b>.
            </span>
          </li>
          <li>
            <span>
              5. Berita acara wajib ditandatangani oleh Validator & SPG terkait.
            </span>
          </li>
        </ol>


        <!-- Komitmen Section -->
        <h6
          class="text-center mt-4 mb-2"
          style="color: #003399; font-weight: bold"
        >
          KOMITMEN Validator
        </h6>

        <p style="font-size: 14px; font-weight:500; color:#003399; text-align: center">
          Validator wajib bersungguh sungguh dalam pelaksanaan validasi hasil stock opname serta melaporkan hasil validasi
          sesuai dengan fakta yang sesungguhnya.
        </p>

        <!-- Button -->
        <div class="text-center mt-3">
          <b-button
            variant="secondary"
            class="px-3"
            style="background: #eee; color: #000; border: 1px solid #999"
            @click="startAudit"
          >
            <b>Saya mengerti dan Siap Memulai</b>
          </b-button>
        </div>



      </div>
    </b-container>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Loader from "@/components/Loader/Loader";
import { fnPOST } from "../../../../api/api-methods";
import { APIPATH_CGC } from "../../../../api/api-paths";
export default {
  components: {
    Loader,
  },
  data() {
    return {
      isLoadingData: false,
      formName: "Audit",
      roles_list: [],
      isLoading: false,
      today: new Date(),
      form: {
        role: null,
        start_limit: null,
        end_limit: null,
        user_nik: null,
        username: null,
      },
      data: null,
    };
  },
  computed: {
    ...mapGetters("session", ["userData"]),
  },
  methods: {
    ...mapActions("session", ["showNotification"]),
    formatDate(date) {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  },
    setData() {
      this.data = JSON.parse(this.$route.params.data);
      console.log(this.data);
      if (this.data) {
        this.tokoId = this.data.store_code;
        this.tokoName = this.data.store;
        this.spgNik = this.data.nik;
        this.spgName = this.data.name;
      } else {
        this.data = JSON.parse(localStorage.getItem("spg_audit"));
        if (this.data) {
          this.tokoId = this.data.store_code;
          this.tokoName = this.data.store;
          this.spgNik = this.data.nik;
          this.spgName = this.data.name;
        } else {
          this.$router.push({ name: "CGCAudit" });
        }
      }
    },

    startAudit() {
      console.log(this.data);
      this.$router.push({
        name: "CGCAuditList",
        params: { data: this.data },
      });
    },
  },
  created() {
    this.setData();
  },
};
</script>
<style src="../CGC.scss" lang="scss" scoped />
